const countAll = {
  count() {
    const th = this;
    const type = arguments[0];
    const arg = arguments;
    let result = 0;
    switch (type) {
      case "+":
        result = th.addition(arg);
        break;
      case "-":
        result = th.subtract(arg);
        break;
      case "*":
        result = th.mul(arg);
        break;
      case "/":
        result = th.division(arg);
        break;
    }
    return result;
  },
  // 取整
  intnum(param) {
    const args = `${param}`;
    const index = args.indexOf(".");
    let doubleLen = 0;
    if (index > 0) {
      doubleLen = args.substring(index + 1).length;
      param = param * 1 * Math.pow(10, doubleLen);
    }
    const p = [0, 0];
    const i = `${param}`.indexOf(".");
    param = Math.round(param); // 取最接近整数
    p.splice(0, 1, param);
    p.splice(1, 1, doubleLen);
    return p;
  },
  // 加法，减法，除法，计算比较麻烦，需要取到小数位数最大的值
  addition(args) {
    const th = this;
    let con = 0;
    const len = [];
    let i;
    const argLen = args.length;
    let arg;
    for (i = 0; i < argLen; i++) {
      if (i > 0) {
        len[i - 1] = th.intnum(args[i])[1];
      }
    }
    const maxLen = Math.max.apply(null, len);
    for (i = 0; i < argLen; i++) {
      if (i > 0) {
        con += th.intnum(args[i])[0] * 1 * Math.pow(10, maxLen - len[i - 1]);
      }
    }
    return con / Math.pow(10, maxLen);
  },
  // 减法
  subtract(args) {
    const th = this;
    let con = 0;
    const len = [];
    let i;
    const argLen = args.length;
    let arg;
    for (i = 0; i < argLen; i++) {
      if (i > 0) {
        len[i - 1] = th.intnum(args[i])[1];
      }
    }
    const maxLen = Math.max.apply(null, len);
    con = th.intnum(args[1])[0] * 1 * Math.pow(10, maxLen - len[0]);
    for (i = 0; i < argLen; i++) {
      if (i > 1) {
        con =
          con * 1 -
          th.intnum(args[i])[0] * 1 * Math.pow(10, maxLen - len[i - 1]) * 1;
      }
    }
    return con / Math.pow(10, maxLen);
  },
  // 乘法需要求到所有取正的倍数
  mul(args) {
    const th = this;
    let con = 1;
    let len = 0;
    let i;
    const argLen = args.length;
    let arg;
    for (i = 0; i < argLen; i++) {
      if (i > 0) {
        arg = th.intnum(args[i]);
        con = arg[0] * 1 * con;
        len += arg[1];
      }
    }
    return con / Math.pow(10, len);
  },
  // 除法需要求最长小数位数
  division(args) {
    const th = this;
    let con = 1;
    const len = [];
    let i;
    const argLen = args.length;
    let arg;
    for (i = 0; i < argLen; i++) {
      if (i > 0) {
        len[i - 1] = th.intnum(args[i])[1];
      }
    }
    const maxLen = Math.max.apply(null, len);
    con = th.intnum(args[1])[0] * 1 * Math.pow(10, maxLen - len[0]);
    for (i = 0; i < argLen; i++) {
      if (i > 1) {
        con =
          ((con * 1) /
            (th.intnum(args[i])[0] * 1 * Math.pow(10, maxLen - len[i - 1]))) *
          1;
      }
    }
    return con;
  }
};
export { countAll };
